'use strict';

import { homeCards } from 'pages/home';
import { moreCards } from 'pages/more';
import { aboutCards } from 'pages/about';
import { clientsCards } from 'pages/clients';
import { contactCards } from 'pages/contact';
import { productsCards } from 'pages/products';

import { defaultLocale } from 'locale';

export default {

    locale: defaultLocale,

    loaded: false,

    global: {
        alert: {}
    },

    router: {
        teardown: true
    },

    cards: {
        ...homeCards,
        ...moreCards,
        ...aboutCards,
        ...clientsCards,
        ...contactCards,
        ...productsCards,
        raw: {}
    },

    layouts: {
        0: { key: 'main', layout: [
            { w: 1, h: 1 },{ w: 2, h: 1 },{ w: 5, h: 2 },
            { w: 3, h: 5 },{ w: 2, h: 2 },{ w: 3, h: 2 },
            { w: 3, h: 2 },{ w: 2, h: 2 }
        ]},
        1: { key: 'more', layout: [
            { w: 2, h: 2 },{ w: 4, h: 2 },{ w: 2, h: 4 },
            { w: 2, h: 2 },{ w: 4, h: 4 },{ w: 2, h: 2 },
            { w: 2, h: 2 }
        ]},
        2: { key: 'products', layout: [
            { w: 1, h: 1 },{ w: 4, h: 3 },{ w: 3, h: 2 },
            { w: 1, h: 2 },{ w: 1, h: 1 },{ w: 1, h: 1 },{ w: 1, h: 1 },
            { w: 3, h: 3 },
            { w: 2, h: 3 },{ w: 3, h: 3 }
        ]},
        3: { key: 'about', layout: [
            { w: 1, h: 2 },{ w: 4, h: 2 },{ w: 3, h: 4 },
            { w: 2, h: 2 },{ w: 3, h: 2 },
            { w: 3, h: 2 },{ w: 3, h: 2 },{ w: 2, h: 2 }
        ]},
        4: { key: 'contact', layout: [
            { w: 1, h: 2 },{ w: 4, h: 2 },{ w: 3, h: 2 },
            { w: 3, h: 2 },{ w: 5, h: 4 },
            { w: 3, h: 1 },
            { w: 3, h: 1 }
        ]},
        9: { key: 'cases', layout: [
            { w: 1, h: 1 },{ w: 2, h: 1 },{ w: 5, h: 6 },
            { w: 3, h: 2 },
            { w: 3, h: 2 },
            { w: 3, h: 1 }
        ]},
        10: { key: '_cases', layout: [
            { w: 1, h: 1 },{ w: 4, h: 1 },
            { w: 5, h: 4 },
            { w: 2, h: 2 },
            { w: 3, h: 2 },
            { w: 5, h: 1 },
        ]},
        5: { key: '_main',  layout: [
            { w: 1, h: 1 },{ w: 4, h: 1 },
            { w: 5, h: 2 },
            { w: 3, h: 4 },{ w: 2, h: 2 },{ w: 2, h: 2 },
            { w: 3, h: 2 },{ w: 2, h: 2 },
            { w: 5, h: 1 }
        ]},
        6: { key: '_more',  layout: [
            { w: 2, h: 2 },{ w: 3, h: 2 },
            { w: 3, h: 4 },{ w: 2, h: 2 },{ w: 2, h: 2 },
            { w: 2, h: 2 },{ w: 3, h: 2 }
        ]},
        7: { key: '_about', layout: [
            { w: 1, h: 1 },{ w: 4, h: 1 },
            { w: 5, h: 2 },
            { w: 3, h: 4 },{ w: 2, h: 2 },{ w: 2, h: 2 },
            { w: 3, h: 2 },{ w: 2, h: 2 },
        ]},
        8: { key: '_contact', layout: [
            { w: 1, h: 1 },{ w: 4, h: 1 },
            { w: 3, h: 2 },{ w: 2, h: 2 },
            { w: 5, h: 2 },
            { w: 3, h: 2 },{ w: 2, h: 2 },
        ]},
    },

    sections: {
        0: { id: 0, key: 'main',     name: 'Home',             layout: 0, tablet: 5 },
        1: { id: 1, key: 'more',     name: 'Mais informações', layout: 1, tablet: 6 },
        2: { id: 2, key: 'contact',  name: 'Contato',          layout: 4, tablet: 8 },
        3: { id: 3, key: 'products', name: 'Produtos',         layout: 2, tablet: 5 },
        4: { id: 3, key: 'about',    name: 'Sobre',            layout: 3, tablet: 7 },
        5: { id: 3, key: 'cases',    name: 'Clientes e cases', layout: 9, tablet: 10 }
    },

    pages: {
        home:     { sections: [0, 1] },
        contact:  { sections: [2, 1] },
        products: { sections: [3, 1] },
        about:    { sections: [4, 1] },
        cases:    { sections: [5, 1] },

    }
};



// WEBPACK FOOTER //
// ./app/state.js